"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.A = exports.combineUrl = exports.decodeParams = exports.encodeParams = exports.routerPlugin = exports.router = void 0;
var router_1 = require("./router");
Object.defineProperty(exports, "router", { enumerable: true, get: function () { return router_1.router; } });
var plugin_1 = require("./plugin");
Object.defineProperty(exports, "routerPlugin", { enumerable: true, get: function () { return plugin_1.routerPlugin; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "encodeParams", { enumerable: true, get: function () { return utils_1.encodeParams; } });
Object.defineProperty(exports, "decodeParams", { enumerable: true, get: function () { return utils_1.decodeParams; } });
Object.defineProperty(exports, "combineUrl", { enumerable: true, get: function () { return utils_1.combineUrl; } });
var anchor_1 = require("./anchor");
Object.defineProperty(exports, "A", { enumerable: true, get: function () { return anchor_1.A; } });
__exportStar(require("./builders"), exports);
//# sourceMappingURL=index.js.map